import React, { useRef, useEffect } from "react";
import {Link, useNavigate} from 'react-router-dom';

export default function CreateNewMission() {

    return (
        <div className="new-mission-widget">
            <div >
                <p>Nouvelle mission</p>
                <h3>Commander une nouvelle mission</h3>
            </div>
            <div >
                <p>Envoyez-nous vos besoins en quelques clics</p>
                <Link to={"/mission-creation"} className={"btn fill green"}>Rechercher une nouvelle mission</Link>
            </div>
        </div>

    );
}